import React from "react";

const Title = (props) => {
  return (
    <>
      <div className="login-title">
        <h2>{props.title}</h2>
        <p>
          {props.tagline1}
          <br /> {props.tagline2}
        </p>
      </div>
    </>
  );
};

export default Title;
